import {Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NextInputService {
    public static $name = 'nextInputService';

    private nextInputSubject = new Subject<any>();
    // tslint:disable-next-line:member-ordering
    public nextInput$ = this.nextInputSubject.asObservable();

    public setNext(params: any) {
        this.nextInputSubject.next(params);
    }

}
